export const environment = {
  API_BASE_URL: 'https://maqi-api.astro.umd.edu',
  AUTH_API_BASE_URL: '',
  AWS_S3_BUCKET: 'sbn-maqi-queries-1',
  DEFAULT_QUERY: 'SELECT * FROM mpc_orbits LIMIT 1;',
  DEFAULT_HISTORY_PAGE_SIZE: 25,
  QUEUE_STATS_VISIBLE_POLL_INTERVAL_MS: 1000,
  AUTH_REFRESH_CHECK_INTERVAL_MS: 60000,
  AUTH_REFRESH_LEEWAY_MS: 300000,
  AUTH_REFRESH_MAX_RETRY_MS: 30000,
};
